import { AspectRatio } from '@mui/joy'
import { ReactNode } from 'react'

interface ParticleIframeProps {
	ratio: string
	children: ReactNode
}
const ParticleIframe = ({ ratio, children }: ParticleIframeProps) => {
	return (
		<AspectRatio ratio={ratio} sx={{ '& iframe': { width: '100%', height: '100%' } }}>
			{children}
		</AspectRatio>
	)
}
export default ParticleIframe
